// iter 392 — tracks real user presence. A desktop with the SCREEN asleep
// but the tab focused still reports visibilityState === "visible", so
// visibility checks alone let idle machines poll heavy endpoints all
// night (measured: 2 idle machines = ~1,900 timeout error-logs/night).
let lastActivity = Date.now();

if (typeof window !== "undefined") {
  const mark = () => { lastActivity = Date.now(); };
  ["pointerdown", "pointermove", "keydown", "touchstart", "wheel"].forEach((ev) =>
    window.addEventListener(ev, mark, { passive: true, capture: true })
  );
}

export function isUserIdle(maxIdleMs = 30 * 60 * 1000) {
  return Date.now() - lastActivity > maxIdleMs;
}
